import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=5d98afbe&scoped=true&"
import script from "./ChatIcon.vue?vue&type=script&lang=js&"
export * from "./ChatIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChatIcon.vue?vue&type=style&index=0&id=5d98afbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d98afbe",
  null
  
)

export default component.exports